import { useTranslation } from "next-i18next";
import { FooterWrapper } from "styles/jss/Footer.styles";
import { Container, Divider, Grid } from "@mui/material";
import { NextImage, SocialSection } from "components";
import { SubsForm, FooterLoading } from "components/Footer";
import Link from "next/link";

export default function Footer({ data, isLoading }) {
  const { t } = useTranslation(["footer"]);
  const { head_office, complex, related_sites, shortcuts, socialLinks, logo } =
    data;

  return (
    <FooterWrapper>
      <Container>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={6}>
            <div className="contactDisc">
              <p className="title">{t("title")}</p>
              {/*<p className="content">{t("content")}</p>*/}
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <SubsForm />
          </Grid>
        </Grid>
        <Divider variant="middle" sx={{ margin: "65px 0 45px 0" }} />
        {isLoading ? (
          <FooterLoading />
        ) : (
          <>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={6}>
                <div className={"logoWrapper"}>
                  <Link href="/">
                    <a>
                      <NextImage
                        src={logo?.data?.attributes?.url}
                        alt="aryasasol"
                        layout={"responsive"}
                        width={144}
                        height={50}
                        objectFit={"cover"}
                      />
                    </a>
                  </Link>
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <SocialSection socialLinks={socialLinks} />
              </Grid>
            </Grid>
            <Divider variant="middle" sx={{ margin: "40px 0 35px 0" }} />
            <Grid
              container
              rowSpacing={{ xs: 4, lg: 0 }}
              columnSpacing={{ sm: 4, md: 6, lg: 10 }}
              justifyContent="space-between"
            >
              <Grid item xs={12} sm={6} lg={3}>
                {!!head_office && (
                  <InfoContent
                    as={"p"}
                    title={t("head_office")}
                    data={head_office}
                    complex={"head_office"}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                {!!complex && (
                  <InfoContent
                    as={"p"}
                    title={t("complex")}
                    data={complex}
                    type={"complex"}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                {!!shortcuts && (
                  <InfoContent
                    as={"ul"}
                    title={t("shortcuts")}
                    data={shortcuts}
                    type={"shortcuts"}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                {!!related_sites && (
                  <InfoContent
                    as={"ul"}
                    title={t("related_sites")}
                    data={related_sites}
                    target="_blank"
                    rel="noopener"
                    tupe={"related_sites"}
                  />
                )}
              </Grid>
            </Grid>
          </>
        )}
      </Container>
      <div className="subfooter">
        <p>{t("copyright")}</p>
      </div>
    </FooterWrapper>
  );
}

const InfoContent = ({ as, data, title, type, ...otherProps }) => {
  const { t } = useTranslation(["footer"]);

  const p_render = () => {
    const { address, postal_code, po_box, telephone, fax } = data;
    return (
      <p>
        {!!address && (
          <span>
            {t("address")}: {address}
          </span>
        )}
        {!!postal_code && (
          <span>
            {t("p_c")}: {postal_code || "-"}
          </span>
        )}
        {!!po_box && (
          <span>
            {t("p_o")}: {po_box || "-"}
          </span>
        )}
        {!!telephone && (
          <span className="num">
            {t("tel")}: <span>{telephone || "-"} </span>
          </span>
        )}
        {!!fax && (
          <span className="num">
            {t("fax")}: <span>{fax || "-"}</span>
          </span>
        )}
      </p>
    );
  };

  const list_render = () => {
    return (
      <ul>
        {data.map(list => (
          <li key={list.id}>
            {type === "shortcuts" ? (
              <Link href={list.url}>{list.label}</Link>
            ) : (
              <a href={list.url} {...otherProps}>
                {list.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className={"info-content"}>
      <p className={"head"}>{title}</p>
      {as === "p" ? p_render() : as === "ul" && list_render()}
    </div>
  );
};
